import React from "react";
import entregaTienda from '../../assets/images/imagesEntrega/recogeTienda.webp';
import envioPais from "../../assets/images/imagesEntrega/envioPais.webp";
import envioDom from "../../assets/images/imagesEntrega/envioDomicilio.webp";

const Entrega = () => {
  return (
    <div className="row d-flex bg-white py-4">
      <div className="col d-flex flex-column align-items-center justify-content-center">
        <a href="https://www.miniso.com.mx/opciones-de-entrega">
          <img
            style={{ width: "20vw", height: "22vw" }}
            className="miEntregaMiniso"
            src={entregaTienda}
            alt="entregaTienda"
          />
        </a>
        <h3 style={{ fontSize: "2vw" }} className="mt-2">
          RECOGE EN TIENDA
        </h3>
      </div>
      <div className="col border-start border-dark d-flex flex-column align-items-center justify-content-center">
        <a href="https://www.miniso.com.mx/faq">
          <img
            style={{ width: "20vw", height: "22vw" }}
            className="miEntregaMiniso"
            src={envioPais}
            alt="envioPais"
          />
        </a>
        <h3 style={{ fontSize: "2vw" }} className="mt-2">
          ENVIOS A TODO EL PAIS
        </h3>
      </div>
      <div className="col border-dark border-start d-flex flex-column align-items-center justify-content-center">
        <a href="https://www.miniso.com.mx/opciones-de-entrega">
          <img
            style={{ width: "20vw", height: "22vw" }}
            className="miEntregaMiniso"
            src={envioDom}
            alt="envioDom"
          />
        </a>
        <h3 style={{ fontSize: "2vw" }} className="mt-2">
          ENVIO A DOMICILIO
        </h3>
      </div>
    </div>
  );
};

export default Entrega;
